import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tu-van-vien/[id]/page.tsx");
